import { render, staticRenderFns } from "./license-information.vue?vue&type=template&id=ca2efbca&"
import script from "./license-information.vue?vue&type=script&lang=js&"
export * from "./license-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "license-information.vue"
export default component.exports